import { Label, Switch } from '@/components/ui';
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type TProps = {
  onCheckedChange: (checked: boolean) => void;
  switchColorOnChecked?: string;
  description?: ReactNode;
  disabled?: boolean;
  className?: string;
  checked: boolean;
  title: string;
};

const ToggleParam = ({ title, description, onCheckedChange, checked, disabled, switchColorOnChecked, className }: TProps) => (
  <div className={cn('flex flex-row items-center justify-between rounded-lg border p-4 space-y-2 space-x-3', className)}>
    <div className='space-y-0.5'>
      <Label>
        {title}
      </Label>
      {
        description &&
        <p className='text-[0.8rem] text-muted-foreground'>
          {description}
        </p>
      }
    </div>
    <Switch
      onCheckedChange={onCheckedChange}
      style={{
        backgroundColor: (
          (switchColorOnChecked && checked)
            ? switchColorOnChecked
            : undefined
        )
      }}
      disabled={disabled}
      checked={checked} />
  </div>
);

export default ToggleParam;
